import getFormattedLabel from './getFormattedLabel';
const getStatusLabel = (prospect) => {
    if (prospect.deactivated) {
        return 'Deactivated';
    }
    if (prospect.prospect_type === 'RTM') {
        const provider_name = prospect.provider_hero_organization || 'N/A';
        const rtmStatus = getFormattedLabel(prospect.rtm_prospect_status);
        const additionalInfo = ['rejected', 'expired'].includes(rtmStatus)
            ? ` by ${provider_name}`
            : '';
        return `RTM ${rtmStatus}${additionalInfo}`;
    }
    if (prospect.prospect_type === 'RTM_REELECTION') {
        return `RTM Reelection ${getFormattedLabel(prospect.rtm_reelection_scenario)}`;
    }
    // fallback for d2c status to order not finished if null or undefined
    const d2cProspectStatus = prospect?.d2c_prospect_status || 'ORDER_NOT_FINISHED';
    const preparedD2cStatus = getFormattedLabel(d2cProspectStatus);
    return `D2C prospect ${preparedD2cStatus}`;
};
export default getStatusLabel;
